export const BACKGROUND_VIDEO_PATH = "/videos/ladle_intro_compressed.mp4";
export const SIDE_LOGIN_IMAGE_PATH = "/images/login/login-pt.png";
export const LOGO_PATH = "/images/login/logo.png";
export const MICROSOFT_ICON_PATH = "/images/login/microsoftIcon.png";
export const PT_DEFAULT_LOGO = "/images/login/logo.png";
